module.exports = __webpack_public_path__ + "img/focus.68ef2493.png";